module.exports = __webpack_public_path__ + "static/sofiapro-400-3a1bad1a3a53e538202f4ce132417667.woff";